document.addEventListener('DOMContentLoaded', () => {
    const popupOverlay = document.getElementById('welcome-popup');
    const closeBtn = document.getElementById('popup-close');
    const lastShown = localStorage.getItem('popupLastShown');
    const now = new Date().getTime();
    // 24時間（ミリ秒換算：24*60*60*1000=86400000）
    const twentyFourHours = 86400000;
    // 前回表示から24時間経過しているかチェック
    if (!lastShown || (now - lastShown) > twentyFourHours) {
      // 一定時間後に表示する例（2秒後）
      setTimeout(() => {
        popup.classList.add('active');
        popupOverlay.style.display = 'flex';
        }, 2000
      );
      localStorage.setItem('popupLastShown', now); // 現在時刻を保存
    }
    // 閉じるボタンを押下した時の処理
    closeBtn.addEventListener('click', () => {
      popupOverlay.style.display = 'none';
      // Cookie などを使って再表示までの間隔を制御してもよい
    });
});
